/* npx update-browserslist-db@latest
##### WHEN CODING IN OpenCaptureReact, ALWAYS REMEMBER UserMobx.c_userCanEditCaptureCardContentTF FOR NEW NON-ADMIN EDITABLE ITEMS #####

$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$
$$$$$$$$    ON-PREMISE CUSTOMERS    $$$$$$$$
$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$
^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
^^^^^^Pending CE/SGT cloud database upgrades (already applied to BITTEST), paste in bitexec 'Upgrade Databases' tab to apply to all other cloud CE/SGT customers^^^^^^
^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^

^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^

//Finished BITEXEC Database Upgrades for On Premise customers
//  1. build code changing commented blocks in CEC.js and general_functions.php (also CETeammateSurveyMobx.js for /team/ build only) {uncommon: check CEC.js on-prem BIT_LICENSE_START_DATE and BIT_LICENSE_NUM_MONTHS, increase if they renewed recently, increase # users if they bought more recently}
//  2. save database update statements below for db_a_companies, db_a_logs, and db_c_COMPANYCODE in .txt files to manually apply in SQL tab
//  3. phpMyAdmin 'Export' tab db_a_companies 'Custom' help/BIT Master/code version tbls [uncheck tbl_companies, tbl_users, x_key_sam] with DROP ('Add DROP TABLE / VIEW / PROCEDURE / FUNCTION / EVENT / TRIGGER statement') and increase 'Maximal length of created query' (also make sure code versions match), to create db_a_companies.sql file ready for import
//  4. give them the latest On Premise Authentication .txt file to upload (update on-prem BIT tbl_companies auth expiration date)
//  5. if any new graphics were uploaded, copy to customer /graphics folder (contains graphics + helppanels, customer logos not sent from /team/)
//  6. do any Manual Admin Work after the install is complete in the CE system

//[[db_a_companies (only tbl_companies, tbl_users, x_key_sam, all others changes picked up in full export)]]


//[[db_a_logs]]


//[[db_c_COMPANYCODE]] {always execute "UPDATE `tbl_a_users_per_email` SET `code_update_01`='1';" at end for on-prem} {don't need code version UPDATE as it is exported above in step 3}


//[[Uploaded '/graphics/' files]]


//[[Manual Admin Work]]



$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$
$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$
$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$
*********done*********
{Skip 10/29/26} onclick_recalculate_shaping_progress_pwin_percents_on_all_captures - offer choice for only active captures [default] or all
<AVION Jacob 10/22/26> Stage select out of order from admin pool
<AVION Jacob 10/22/26> remove (optional) from 'Comments (optional)' on the Teammates Survey
---------released 10/31/26---------
<Skip bug 11/2/26> Capture Table Inline Edit - click Contact cell does not open correct tab/contact
Contacts import SAM Entities - include Other NAICS and Business Types (Set Asides) in import
<CHENEGA_EHFBU Bryan 10/29/26> bug 3rdPartyIntegration - update details field COV, need to update followon computed variables that don't have tbl_captures columns (allocated net, etc), same for CSD/PoP, etc
---------released 11/03/26---------
---------released 11/XX/26---------
---------released 11/XX/26---------
---------released 11/XX/26---------
---------released 11/XX/26---------
---------released 11/XX/26---------
**********************
???????????/
when a SAM Entity is imported as a Contact, set business_type_id to the first row id from #sym:o_tbl_a_business_types where is_sb_type_01 is 1 (small business type) ?????
???????????/





companies/persons/team/comp
- talk about way to order/rename/hide hardcoded&extra fields together
- select/shared/number custom field types



competitor analysis swot hard to read
implement set-asides import from entities c32/c35

govwin - get dept/ag/subtier in from govEntity link parentHierarchy of "ARMY"

Gate Reviews - Divexec - show me all past approvals
Stage Flow - maybe all blocks (move forward, no bid, cancel) per stage have these 3 categories and are fixed as the same size, have in move forward block a number with an arrow showing it moved forward











{????} Contacts - develop CE Android/iOS app for camera import of business cards, then put imports into customer contacts in 'awaiting import' section

Contacts - SAM entities - can view all historical wins on a graph and read about those deals (from SAM CE database of Award Notices)




{????} ContactCompanies/ContactPersons/Teammates/Competitors - new structure for custom fields to be select/selectmulti/sharedpercent/date/money/int/dec - all data stored in TEXT, select data stored as JSON arrayOfObjs in field definition tbls









Tapestry/ribbons/View Buttons - also custom per user button widths





{AGEISS Brian 10/22/26 video call}
- AI chat for whole system, summarize all caputre data
- AI summarize this GCSS deal (description and doc contents)
- [FedComp] GSA MAS schedule, Oasis+ (Ebuy?, GSA, ), ingests them gives in an email every morning
ebuy.gsa.gov/ebuy/ (yes always 2FA to email)
set up AGEISScegsa@bitsolutionsllc.com, Brian will forward emails to this
APFS - example email

{CHENEGA_PSBU Carole 10/2/26} Admin 7.DDF - add fields to Advance Stage Debrief for Closed Stages, show up on Advance Stage in new card for Debrief Fields

{CHENEGA_PSBU Team 9/17/26} Ebuy integration

{AVION Steve 9/2/26} many items


{DDI Austin Adams 10/15/26 call with Skip} OR View Button filters together
{DDI Josh 9/10/26 Natalie email} #1 Custom Select User field - notify when create/added/removed from Capture

<Natalie bug 7/15/26 INDIGOIT> deactivate users remove captures still have captures assigned!!!!



{Drew/someone? 10/21/26} Stage View - favorite should be at top of list per stage



{AVIAN Kelly 8/30/26} revenue card calc forecast fields codewords

{CHENEGA_PSBU TomDo/Carole 8/12/26 vid call} Add new Capture - if setting a field that's on the New Capture setup, other fields can get values based on how those fields are set














{INDIGOIT 7/15/26 Brenda email} export calendar to .csv, propmgt as first tab?, work assignments!

make contacts faster with new computed var that doesn't have secondary levels, no complicated masking

{7/14/26 STRONGBRIDGE Drew Brenda email} Contacts more like CRM
{6/18/26 Chenega Caroline} allow adding shaping questions to CST columns, blank cells at login, click a button to load those values


CHENEGA Natalie email todos 6/3/2026 and 7/13/26

upload docs - AI to show progress bars and unlimited upload size

enter new UEI codes, also search for UEIs does not handle ' properly

<bug Skip 1/29/2026> Capture from GCSS - assign you and another person as capture managers, that person should get a notification/email

diagnose import capturemanagers undefined from chenega auto assign unassigned for capture team

{QSL Wendy 2/27/2026} Competitors search field - like [display_name:"Teammate Total Allocation % (Us+LB+SB)",     db_name:"nc_teammate_total_alloc_perc_uslbsb"], make a new tbl_captures column to list all competitors when competitor card changes are made

TonyGGCB - Contact Companies - create new company A|B switch for 'Manual' or 'UEI Select' at top
-move these contact company fields into permanent fields: (study all customers)
-   Address Line 1
-   Address Line 2
-   City
-   State
-   Zip
-   Country
-   Web Address


//no [[+filter]] present needs to print no filter for each codeword


Add system field Proposal Submit Date/Time

PPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPP
REMOVE!
get_capture_type_stage_info_obj_from_capture_type_id()

restrict non-edit users with UserMobx.c_userCanEditCaptureCardContentTF in proposal card

PropMgmt Snapshot
c_ocpmOpenCaptureProposalDueDateTimeLocalTwoLinesValueMask
2 line datetime on snapshot (edit databasemobx implementation of datetime masking for new 2 line format, use that valueMask field)
click on card, open subtab 2 PM first if process is started, otherwise #1 themes


notificaitons:
- propmgr assignment
- writing assignment to person
- writing set as finished
- calendar change notifications


[[[[[[[[[]]]]]]]]]
sorting events in day cell test
zoom fit events test
can make end date earlier than start date?? (test in update and create new)

Admin: new option for capture new Prop process screen: "A" / "B" / "Both"
need all functionality for assigning prop manager, prop exec can see all assignment requests from capture, make assignment (when pending, say so on capture card face for CM)
-delete entire process (should be on 'pending PM assignment' middle page to cancel that request)
mechanism create new event for change start date auto changes end date to same date (esp if dates cross over each other when edited) [maybe switch to enter duration or end date]
[[[[[[[[[]]]]]]]]]



<4/2/26 Skip> Proposal Card Snapshot? - red if past due date and in Proposal Stage (unknown what that stage is??), green if in submission type stage past date
add duration to o_tbl_a_pm_milestones in whole days (int)
when offering colors for each milestone on a capture, collect all unique color choices across sequences and milestones as easy picks, or allow custom color choice


fill in i_copyProposalThemes01 in php for all new proposal features and tbls


Proposal Management (2026-02-12)
display "title/role" when selecting Users from Selects?
Proposal Support License Cost: 0.2, also login limits data to only assigned captures
ALL current system User Selects – need a more restricted source list of Users that excludes all Proposal Support Users (can’t assign a PS User to a Capture Team)



Proposal Manager Dashboard – ToDo List
[clicking a ToDo item opens the full capture, opens the Prop Card, opens the 2nd subtab for Proposal Management]



Proposal Management (2025-07-10)
2 new power levels propmgr, propexec - propmgr assiged to a capture can edit proposal process, propexec can edit any capture proposal process, other powers can not edit process (view only overview) unless they are named as assigned propmgr
Propmgr can view/assign all pool of PropUsers (graphics, writers, etc)
- new db tbl for proposals (max of 1 record per capture_id) (need column for id, capture_id, requested_propmgr_by_user_id, request_propmgr_date, assigned_propmgr_by_user_id, assigned_propmgr_date, assigned_propmgr_user_id)
- takeover capture card PropThemes for 'Proposal Process' (themes first on left half, new on right half) - 2 options (turn off/on either path in new Admin subtab):
  1) 'Request Proposal Manager for this Capture' - puts this capture on the propexecs dashboard to assign to a propmgr using availability timeline of all propmgrs (busy on other captures or on vacation, etc)
  2) 'Assign Proposal Manager to this Capture' - can pick from any propexec/propmgr and make assignment yourself
- only 1 CE Propexec/Propmgr user can be assigned as proposal manager - then 'roles' are assigned to internal/external people below them (emails sent to them with invites)

'Proposals' tbl (1 per capture or 0, but possibly could apply multiple templates to a calendar with different due dates)
- id, capture_id, requested_propmgr_by_user_id, request_propmgr_date, assigned_propmgr_by_user_id, assigned_propmgr_date, assigned_propmgr_user_id, selected_prop_turnaroundtimetemplate_id

'Proposal Milestone DateTimes' tbl (every date in Turnaround Template as separate row, all proposalIDs mixed together)
- id, capture_id, milestone_id, milestone_start_datetime, ce_users_involved, external_contacts_involved, meeting_location, notes

[DONE] 'Proposal Turnaround Timeline Templates' tbl (Admins or PropExecs both can create/edit/delete, start with Admin)
- id, date_name, +/-#days_post_rfpdate (or -days from propduedatetime)
- each template has unlimited 'Sequences' to add with a title and sequence color, milestones added in sort order under each Sequence (in a proposal process, the current milestones are 1 from each parallel 'Sequence' based on today's date)
- all added milestones can have an optional 2nd 'Calendar Color' ("" in database if no calendar color) and font color (bk,gr,wh), color shows up as tiny dot inside rhombus, colors the calendar with that color on that date
- current milestone(s) per sequence lit up based on today's date, can't be manually moved (have to edit dates on calendar, gives option when editing a date to shift all dates in front of it same # days with checkboxes)
    Calendar is about 10 weeks tall on a screen, current week default centered in middle, can move by 1 week, 1 month, 1 year up or down
- calendar needs a 'play' mode to move dates around without affecting database, then 'publish' to push out changes to everyone
    Multiple 'timeline/calendar' views




Proposal:
Admin new external/internal "Proposal Support Users" mini-Users
- can create blocks of proposal Support that show up between 'Users' and 'Deactivated' - can add Users (real tbl_a_upe/tbl_a_u records) that either work with real email/name (internal prop Support) or point to a Contact Person to get name/email from there to log in
- per capture (per proposal) assign a 'Role' to a User for that proposal (Writer, Graphics, Editor, Color Team Reviewer, Orals Coach, Deputy Proposal Manager, Book Boss, etc) (custom admin list of roles that can be custom edited)



Proposal ToDo: (*Order for Drew to code so that infrastructure of database is in place    *Order that actualy proposals go)
1. Finish Admin Turn/Seq/Mile Admin <bug in 'view calendar' picking wrong one>
2. Admin Users 'blocks' of 20 Users (3-license cost), way to create those users
3. Capture Manager request proposal process assignment or assign their own manager
4. PropMgr apply template to capture prop calendar, can shift dates, edit start/end datetimes notes locations, create new sequences/milestone, change colors
5. PropMgr create breakdown writing sections, assign writing to "people", lights on progress, documents repository with links
6. Build external 'litte CE login' for 'Proposal Support Users' to view only their work to do
7. Time management of PropMgrs managing PSUs for multiple captures/proposals
8. Time management of color/graphics/writers time
9. Exec health of company multiple captures/proposals
eventually:
- get new .jpg of capture card snapshot ProposalManagement when finished
- openCaptureMobx o_copyCaptureProposalManagementTF - new code for copying new data within Proposal Management for the open capture

Spencer meet
- https://www.peakproposals.com/blog/never-miss-a-proposal-deadline
- when applying templates to a new capture proposal process, ability to look at milestone pool and build a full timeline from scratch adding things from the pool (select a pool milestone or create a brand new one with a new name from scratch)
- maybe each milestone should have an optional start datetime and end datetime (and invitees, meeting location, notes), but still lasts as a 'period' until the next milestone start date
- automated calendar invites would be helpful
PPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPP



refactor all of ce_datetime tools (convert to a created 'ceDateObj' with many fields and tf flags, then functions to convert that into YmdHiA, local, etc)
- convert_ce_datetimeutc_to_mysqldatelocal is not named in the convention of "get_Ymd_date_from_ce_datetimeutc"
- also maybe new name for cedatetimeutc without "_"
- proposal_due_datetime_utc should have an input_type of "cedatetimeutc" instead of "datetime" to be more specific, also new Capture Field that can be created in subtab 7 for CEDate/Time type fields where "time can be Not Set, hours/minutes only"

find tbl_c_pm_proposals in php and pass those tbl names from js instead of hardcoding them in php
also $i_api === "copyCaptureData" remove hardcoded tbl names

remove tbl_ref_from_tbl_name() and tbl_row_map_from_id




XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX




{CHENEGA_PSBU Tom 9/25/25} GCSS GovWin - Dept/Ag/Subtier (from GovEntity link), Incumbent (from Contracts link)
- bitexec analyzer for all GovWin fetched fields
- new category "Incumbent Information" {all data inside "contracts" href}      (change Award Info to Award Information)
"contracts" {
  awardDate	:	2025-05-28T00:00:00.000
  company	: {id	:	7394328, name	:	Choctaw Premier Services LLC}
  contractNumber	:	W9124D25CA008
  estimatedValue	:	88504
  expirationDate	:	2026-10-03T00:00:00.000
  id	:	778597
  title	:	ARMY TRANSITION ASSISTANCE PROGRAM SERVICES
}
new Fields in that new section:
* "Incumbent Company Name"
* "Incumbent Contract Number"
* "Incumbent Contract Title"
* "Incumbent Award Date"                  (need to convert date/time to date)
* "Incumbent Contract Expiration Date"    (need to convert date/time to date)
* "Incumbent Value"                       (need to convert from 1000s of dollars raw value to normal $ in CE, x1000)
* "Incumbent Additional Contracts"        (textarea, #0 is in the fields above, indices #1-#N are looped as text into this)

"Incumbent Additional Contracts"
Incumbent Company Name: XXX
contract number: XXX
contract title: XXX
Incumbent Award Date: XXX
Incumbent Contract Expiration Date: XXX
Incumbent Value: XXX
Incumbent Additional Contracts: XXX
-----------------------------------------------
Incumbent Company Name: XXX
contract number: XXX
contract title: XXX
Incumbent Award Date: XXX
Incumbent Contract Expiration Date: XXX
Incumbent Value: XXX
Incumbent Additional Contracts: XXX
-----------------------------------------------
Incumbent Company Name: XXX
contract number: XXX
contract title: XXX
Incumbent Award Date: XXX
Incumbent Contract Expiration Date: XXX
Incumbent Value: XXX
Incumbent Additional Contracts: XXX




**also, look in "contacts" href link fetch to get Dept/Ag and Subtier, always use contact #0
contacts		[3]
links		{1}
govEntity		{1}
  href	:	https://services.govwin.com/neo-ws/govEntities/25223
  contactId	:	30838632
  country	:	United States
  email	:	christine.frate@nih.gov
  firstName	:	Christine
  govEntityLevel1	:	HEALTH AND HUMAN SERVICES         <- Dept/Ag
  govEntityLevel2	:	NATIONAL INSTITUTES OF HEALTH     <- Subtier
  lastName	:	Frate
  modifiedDate	:	2025-09-10T20:50:35.457
  phone	:	301-443-3846


XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX

AGEISS Brain email 1/13/26 - requested features
Ticket - Microsoft SSO

GCB/Spencer - bitexec like 'system unifier' to alert across multiple CE customer databases for pertinent info



//Teammate prime to sub to prime
1. BITTEST going Prime to Sub
2. BITTEST going Sub to Prime
3. (ISC2) going Prime to Sub
4. (ISC2) going Sub to Prime
Teammate dots on right, new first option 'Make this Company the Prime', opens a floating box
 - title: 'Change 'ISC2' from Sub to Prime'
 - - 'ISC2' will become the Prime Company
 - - 'BITTEST' will become a Sub Company [unless selecting from prime company, then need to pick who if anyone to swap with to become prime]
 - You must select a Capture Type for BITTEST to be a Sub (only need this if 'Us' is moving, if Sub and moving contact to contact, no need to change capture type)
 - [Select that contains all Sub Capture Types as its options]


Ebuy integration to GCSS data source



NAICS: 221119,226000,230000,233320,235310,236110,
314911,314912,315211,315221,315299,316991,
322222,323122,325131,325410,
331111,311990,
322222,323000,
332110,332214,
333240,333298,333313,333410,333412,333512,333518,333610,333990,
334000,334414,
335000,335212,
336000,336311,336312,336321,336322,336400, 336410,336610,
339110,339932,339990,
421430,421690,423100,443112,443130,454312,454319,484000,488990,493000
512190,512220,513200,513310,514190,514210,514340,517211,517212,517310,517400,517910,518111,518112,523100,530000,531000,531100,540000,541000,541190,541300,541600,541610,541700,561000,561100,561200,561400,
610000,611200,611700,
711300,722212,722300,
811000,811300, 
PSC: AR, E1MG
*/


//React imports
import React from 'react';
import ReactDOM from 'react-dom/client';
//import reportWebVitals from './reportWebVitals';

//MobX imports
import { configure } from 'mobx';
import { Provider } from 'mobx-react';

//css sheet for entire system
//  - defines default behavior for all html primitive tag types (div, input)
//  - defines basic classes used throughout for colors, font, hover, flex positioning, standard margins/padding (micro, small, med, big, huge)
//  - react divs use these classes while also defining their style (mostly borders and background)  <div className="class1 class2" style={{property:"value"}} />
//  - some standard colors are defined in JSFUNC as functions with the prefix "color_"
import './Library/LibraryReactCss.css';
import './index.css';

//main react component CaptureExec for entire system (login process and logged in system)
import CaptureExec from './CaptureExecReactMobxPairs/CaptureExec/CaptureExecReact.js';

//php interface functions - used here to catch the window errors and send them to the z_errors tbl in the database
import * as JSPHP from './CaptureExecLocalDatabaseMobx/JSPHP.js';

//mobx stores - control the state for React (passed through all components using mobx <Provider>)
// - @observable: data fields used to inject data into components (assign/manipulate/return these values in the computed/action methods by calling this.observableField)
// - @computed: methods for returning computed values using only the observable data fields
// - @action: methods to call from component click/change events that manipulate state observable data fields
//mobx - mark each component that renders using store data as observer and inject listed data stores to use them   @inject("StoreData1", "StoreData2") @observer...
import AdminMobx from './CaptureExecReactMobxPairs/Admin/AdminMobx.js';
import AdminImportMobx from './CaptureExecReactMobxPairs/AdminImport/AdminImportMobx.js';
import AdminIntegrationsMobx from './CaptureExecReactMobxPairs/AdminIntegrations/AdminIntegrationsMobx.js';
import BudgetMobx from './CaptureExecReactMobxPairs/Budget/BudgetMobx.js';
import CapturesMobx from './CaptureExecReactMobxPairs/Captures/CapturesMobx.js';
import CaptureExecMobx from './CaptureExecReactMobxPairs/CaptureExec/CaptureExecMobx.js';
import ContactsMobx from './CaptureExecReactMobxPairs/Contacts/ContactsMobx.js';
import DivexecMobx from './CaptureExecReactMobxPairs/Divexec/DivexecMobx.js';
import GCSSMobx from './CaptureExecReactMobxPairs/GCSS/GCSSMobx.js';
import OpenCaptureMobx from './CaptureExecReactMobxPairs/OpenCapture/OpenCaptureMobx.js';
import ProposalManagementMobx from './CaptureExecReactMobxPairs/ProposalManagement/ProposalManagementMobx.js';
import RightPanelMobx from './CaptureExecReactMobxPairs/RightPanel/RightPanelMobx.js';
import SamGovTrackerMobx from './CaptureExecReactMobxPairs/SamGovTracker/SamGovTrackerMobx.js';
import TeammateContractsMobx from './CaptureExecReactMobxPairs/TeammateContracts/TeammateContractsMobx.js';

import DatabaseMobx from './CaptureExecLocalDatabaseMobx/DatabaseMobx.js';
import UserMobx from './CaptureExecLocalDatabaseMobx/UserMobx.js';
import DevelopmentInitializeDataMobx from './CaptureExecLocalDatabaseMobx/DevelopmentInitializeDataMobx.js';


//MobX configuration for enforcement of better code writing practices https://mobx.js.org/configuration.html
configure({
  enforceActions: "always", //The goal of enforceActions is that you don't forget to wrap event handlers in action. "always" - State always needs to be changed through actions, which in practice also includes creation.
  computedRequiresReaction: true, //Forbids the direct access of any unobserved computed value from outside an action or reaction. This guarantees you aren't using computed values in a way where MobX won't cache them.
  reactionRequiresObservable: true, //Warns when a reaction (e.g. autorun) is created without accessing any observables. Use this to check whether you are unnecessarily wrapping React components with observer, wrapping functions with action, or find cases where you simply forgot to make some data structures or properties observable.
  observableRequiresReaction: true, //Warns about any unobserved observable access. Use this if you want to check whether you are using observables without a "MobX context".
  disableErrorBoundaries: true //By default, MobX will catch and re-throw exceptions happening in your code to make sure that a reaction in one exception does not prevent the scheduled execution of other, possibly unrelated, reactions. This means exceptions are not propagated back to the original causing code and therefore you won't be able to catch them using try/catch.
});

//MobX - Use spec compliant transpilation for class properties
// - Warning: When using MobX with TypeScript or Babel, and you plan to use classes; make sure to update your configuration to use a TC-39 spec compliant transpilation for class fields, since this is not the default. Without this, class fields cannot be made observable before they are initialized.
// - TypeScript: Set the compiler option "useDefineForClassFields": true., Babel: Make sure to use at least version 7.12, with the following configuration:
// - For verification insert this piece of code at the beginning of your sources (eg. index.js) (will show completely blank (gray) screen if it throws this Error, which can be seen in F12 menu)
//if (!new class { x }().hasOwnProperty('x')) throw new Error('Transpiler is not configured correctly');

//catch all for javascript errors that would show as red text in the chrome F12 "console" tab, send these errors to the BIT Solutions z_errors database
window.onerror = (i_message, i_source, i_lineNumber, i_columnNumber, i_errorObj) => {
  const jsDescription = "index.js - window.onerror()";
  const errorMessage = "Message: " + i_message + "\r\nSource: " + i_source + "\r\nLine Number: " + i_lineNumber + "\r\nColumn Number: " + i_columnNumber + "\r\nError: " + i_errorObj.stack;
  JSPHP.record_z_error(jsDescription, errorMessage);
  return(false); //returning true will prevent the firing of the default handler, and returning false will let the default handler run
};

//combine all Mobx Stores used in system into single obj to pass as multiple inputs to <Provider>
const mobxStoresObj = {AdminMobx, AdminImportMobx, AdminIntegrationsMobx, BudgetMobx, CapturesMobx, CaptureExecMobx, ContactsMobx, DivexecMobx, GCSSMobx, OpenCaptureMobx, ProposalManagementMobx, RightPanelMobx, SamGovTrackerMobx, TeammateContractsMobx, DatabaseMobx, UserMobx, DevelopmentInitializeDataMobx};

//replace the <div> root in index.html with the CaptureExec react code
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider {...mobxStoresObj}>
      <CaptureExec />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
